import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55f9b1a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Page" };
const _hoisted_2 = { class: "Picture absolute size-0 flex justify-center items-center" };
const _hoisted_3 = { class: "container relative place-items-center gap-y-16 h-full pt-56 pb-20 lg:pt-0 lg:pb-72" };
const _hoisted_4 = { class: "col-span-full max-w-cols-8 lg:max-w-cols-4" };
const _hoisted_5 = { class: "relative flex flex-col gap-32 lg:gap-56 -mx-gutter lg:mx-0 text-center" };
const _hoisted_6 = { class: "lg:relative" };
const _hoisted_7 = { class: "BackgroundHeading absolute inset-0 -z-1 flex justify-center items-center" };
const _hoisted_8 = { class: "font-screamer font-bold uppercase whitespace-nowrap text-black opacity-5" };
const _hoisted_9 = { class: "BackgroundHeading__Title" };
const _hoisted_10 = { class: "Body relative flex flex-col" };
const _hoisted_11 = { class: "Body__Title" };
const _hoisted_12 = { class: "Body__Description" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Logos col-span-full flex flex-wrap justify-center items-center gap-16 lg:gap-x-40 max-w-full px-16 lg:px-0" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-56 lg:h-[5.375rem]",
        src: "/assets/images/partners/logo-claimsconference-black.png",
        srcset: "/assets/images/partners/logo-claimsconference-black.png 1x, /assets/images/partners/logo-claimsconference-black@2x.png 2x",
        alt: "Claims Conference",
        width: "182",
        height: "81"
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-20 lg:h-24",
        src: "/assets/images/partners/logo-usc-shoah-black.png",
        srcset: "/assets/images/partners/logo-usc-shoah-black.png 1x, /assets/images/partners/logo-usc-shoah-black@2x.png 2x",
        alt: "USC Shoah Foundation",
        width: "151",
        height: "23"
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-16 lg:h-20",
        src: "/assets/images/partners/logo-makemepulse-black.png",
        srcset: "/assets/images/partners/logo-makemepulse-black.png 1x, /assets/images/partners/logo-makemepulse-black@2x.png 2x",
        alt: "makemepulse",
        width: "132",
        height: "19"
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-20 lg:h-24",
        src: "/assets/images/partners/logo-unesco-black.png",
        srcset: "/assets/images/partners/logo-unesco-black.png 1x, /assets/images/partners/logo-unesco-black@2x.png 2x",
        alt: "unesco",
        width: "113",
        height: "25"
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-16 lg:h-20",
        src: "/assets/images/partners/logo-meta-black.png",
        srcset: "/assets/images/partners/logo-meta-black.png 1x, /assets/images/partners/logo-meta-black@2x.png 2x",
        alt: "Meta",
        width: "93",
        height: "19"
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-auto max-w-none h-56 lg:h-[5.3125rem]",
        src: "/assets/images/partners/logos-partners-02-black.png",
        srcset: "/assets/images/partners/logos-partners-02-black.png 1x, /assets/images/partners/logos-partners-02-black@2x.png 2x",
        alt: "Claims Conference",
        width: "271",
        height: "86"
    })
], -1));
import { ref, computed } from "vue";
import { SplitText } from "gsap/SplitText";
import useGSAP from "@/composables/useGSAP";
import useMouseParallax from "@/composables/useMouseParallax";
import Viewport from "@/store/modules/Viewport";
import { setFPS } from "@/utils/frameToTime";
import content from "@/config/content";
export default /*#__PURE__*/ _defineComponent({
    __name: 'About',
    setup(__props) {
        const gsap = useGSAP();
        const frames = setFPS(60);
        const pictures = ref(null);
        const { stop: stopPicturesParallax } = useMouseParallax(pictures, { amplitude: 10 });
        const images = computed(() => ([
            content.chapters[2].image,
            content.chapters[0].image,
        ].map((image) => (Object.assign(Object.assign({}, image), { src: [`${image.src}.avif`, `${image.src}.webp`] })))));
        function onBeforeEnter(el) {
            const $ = gsap.utils.selector(el);
            gsap.set($(".BackgroundHeading__Title"), { opacity: 0 });
        }
        function onEnter(el) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                defaults: {
                    ease: "ease.out"
                }
            })
                .from($(".Title, .Body"), {
                opacity: 0,
                duration: frames(60)
            }, 0)
                .from($(".Logos"), {
                yPercent: 50,
                opacity: 0,
                duration: frames(60)
            }, frames(25));
            // Heading in background
            tl.add(() => {
                const [el] = $(".BackgroundHeading__Title");
                const title = new SplitText(el, { type: "chars" });
                // sort chars by even then odd
                const chars = title.chars
                    .map((char, index) => ({ index, char }))
                    .sort((a, b) => a.index % 2 - b.index % 2 || a.index - b.index)
                    .map(({ char }) => char);
                gsap.set(chars, { opacity: 0 });
                gsap.set(el, { clearProps: "opacity" });
                return gsap.to(chars, {
                    keyframes: {
                        "0%": { opacity: 0 },
                        "25%": { opacity: 1 },
                        "50%": { opacity: 0 },
                        "100%": { opacity: 1, ease: "ease.out" },
                        easeEach: "none"
                    },
                    duration: frames(80),
                    ease: "none",
                    stagger: frames(3)
                });
            }, 0);
            // Pictures animation
            tl.add((() => {
                const pictures = $(".Picture");
                const stagger = frames(6);
                const tl = gsap.timeline({
                    defaults: {
                        duration: frames(60),
                        ease: "ease.out"
                    }
                });
                pictures.forEach((picture, i) => {
                    const frame = picture.querySelector(".Frame");
                    gsap.set(picture, { rotation: [-82, 88][i] });
                    const { left, right } = frame.getBoundingClientRect();
                    gsap.set(picture, { x: i ? Viewport.windowWidth - left : -right, y: 250, filter: "brightness(12)" });
                    tl.to(picture, {
                        x: 0,
                        y: 0,
                        rotation: [-8, 8][i],
                        filter: "brightness(1)",
                    }, i * stagger)
                        .float(picture, {
                        amp: 10,
                        duration: [5, 6],
                    }, ">");
                });
                return tl;
            })(), 0);
        }
        function onBeforeLeave(el) {
            const $ = gsap.utils.selector(el);
            gsap.killTweensOf($(".Picture"));
            stopPicturesParallax();
        }
        return (_ctx, _cache) => {
            const _component_UIPicture = _resolveComponent("UIPicture");
            const _component_UIMaskReveal = _resolveComponent("UIMaskReveal");
            const _component_PageLayout = _resolveComponent("PageLayout");
            return (_openBlock(), _createBlock(_component_PageLayout, {
                class: "About",
                onBeforeEnter: onBeforeEnter,
                onEnterContent: onEnter,
                onBeforeLeave: onBeforeLeave
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            ref_key: "pictures",
                            ref: pictures,
                            class: "Pictures absolute inset-0 hidden lg:block"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(_component_UIPicture, _mergeProps(image, { border: "paper" }), null, 16)
                                ]));
                            }), 256))
                        ], 512),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_UIMaskReveal, {
                                        as: "h1",
                                        class: "Title text-mobile-title lg:text-desktop-subtitle-1",
                                        delay: _unref(frames)(50)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("about.title")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["delay"]),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("about.background_heading")), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createVNode(_component_UIMaskReveal, {
                                                    as: "h2",
                                                    class: "my-16 text-desktop-cap",
                                                    delay: _unref(frames)(30)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('about.subtitle')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["delay"])
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _createVNode(_component_UIMaskReveal, {
                                                    class: "my-16 lg:my-40 text-mobile-body lg:text-desktop-body text-pretty whitespace-pre-line",
                                                    delay: _unref(frames)(40)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('about.description')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["delay"])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _hoisted_13
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
